<div class="master-credential-main d-flex flex-column">
  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <button class="back-btn" type="button" (click)="navigateBack()">
        <img src="/assets/svg/ico-chevron-back-outline.svg" alt="Back" />
      </button>
      <div class="title-wrapper">
        <div class="subtitle">
          <app-with-tooltip [showHelpCursor]="true">
            {{ sharedData?.selectedSite?.siteName || ("MY_SITE" | translate) }}
          </app-with-tooltip>
        </div>
        <h2 class="title-text">{{ "MASTER_CREDENTIAL" | translate }}</h2>
      </div>
      <button class="close-btn" type="button" (click)="closeDialog()">
        <img src="/assets/svg/ico-hamburger-close.svg" alt="Close" />
      </button>
    </div>
  </div>

  <!-- Cards list -->
  <div class="content-container">
    <ng-container *ngIf="!isLoading">
      <!-- List of cards when data is available -->
      <div
        class="credential-card-model"
        *ngIf="masterCards?.length; else noMasterCredentialState"
      >
        <div class="credential-card" *ngFor="let card of masterCards">
          <div class="card-left">
            <div class="card-icon-wrapper">
              <img
                src="/assets/svg/master-credential-card-grey.svg"
                alt="Card"
              />
            </div>
            <div class="card-text">
              <div class="card-name">
                <div class="card-name-text">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ card.cardName }}
                  </app-with-tooltip>
                </div>
                <span
                  class="status-pill"
                  [ngClass]="{
                    'status-active': card.cardStatus === ('ACTIVE' | translate),
                    'status-pending':
                      card.cardStatus === ('PENDING' | translate),
                    'status-blocklisted':
                      card.cardStatus === ('PENDING_BLOCKED' | translate),
                    'status-ready-to-block':
                      card.cardStatus === ('BLOCKED' | translate)
                  }"
                >
                  {{
                    card.cardStatus === ("PENDING_BLOCKED" | translate)
                      ? ("BLOCKLISTED" | translate)
                      : card.cardStatus === ("BLOCKED" | translate)
                      ? ("READY_TO_BLOCK" | translate)
                      : (card.cardStatus | titlecase)
                  }}
                </span>
              </div>
              <div class="card-id">
                <span class="card-id-label">
                  {{ "ID_LABEL" | translate }}
                </span>
                <span class="card-id-value">
                  {{ card.badgeId }}
                </span>
              </div>
              <div class="card-user">
                {{ card.creatorName }}
              </div>
            </div>
          </div>
          <div
            class="card-right"
            (click)="navigateToMasterCredentialDetail(card)"
          >
            <img
              src="/assets/svg/ico-chevron-forward-outline.svg"
              class="chevron-icon"
              alt="Details"
            />
          </div>
        </div>
      </div>

      <!-- Empty state when there are no master credentials -->
      <ng-template #noMasterCredentialState>
        <div class="empty-master-state">
          <div class="empty-master-icon-wrapper">
            <img
              src="/assets/svg/ico-white-card.svg"
              alt="No Master Credential"
            />
          </div>
          <div class="empty-master-title">
            {{ "MASTER_CREDENTIAL_EMPTY_TITLE" | translate }}
          </div>
          <div class="empty-master-subtitle">
            {{ "MASTER_CREDENTIAL_EMPTY_SUBTITLE" | translate }}
          </div>
        </div>
      </ng-template>

      <!-- Bottom info banner -->
      <div class="info-banner">
        <div>
          <img
            src="/assets/svg/ico-info-blue.svg"
            class="info-icon-image"
            alt="Details"
          />
        </div>
        <div class="info-master-text">
          {{ "MASTER_CREDENTIAL_INFO_INTRO" | translate }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
